import { httpsCallable } from "firebase/functions";
import { functions } from "../lib/firebase";

// Visitas anônimas ao site por dia. As regras do Firestore não liberam a
// coleção `siteVisits` para o cliente: a leitura passa pela callable
// getSiteVisits, que checa role admin no servidor (functions/siteVisits.js).

const getSiteVisitsCallable = httpsCallable(functions, "getSiteVisits");

// → { today: 'YYYY-MM-DD', hour: 0-23, days: [{ date, visits, uniqueVisitors, hours }] }
export const getSiteVisits = async () => (await getSiteVisitsCallable({})).data;
